var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c2-button',{on:{"click":_vm.onAddOption}},[_vm._v("Add Option")])
}
var staticRenderFns = []

export { render, staticRenderFns }